import React, { FunctionComponent, useState } from "react";
import { basicTranslator, UseIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { FormWizardTemplate, FormWizardTitle } from "@iventis/components";
import { Content } from "@iventis/translations";
import EnumToRadioButtons from "@iventis/components/src/enum-to-radio-buttons";

export enum DaysToExportType {
    ALL_DAYS = "ALL_DAYS",
    SELECTED_DAY = "SELECTED_DAY",
}

export const ExportRunSheetFormComponent: FunctionComponent<{
    venueName: string;
    onClose?: () => void;
    onConfirm?: (daysToExport: DaysToExportType) => void;
    translate?: UseIventisTranslate;
}> = ({ venueName, onClose, onConfirm, translate = basicTranslator }) => {
    const [daysToExport, setDaysToExport] = useState<DaysToExportType>(DaysToExportType.SELECTED_DAY);

    return (
        <FormWizardTemplate
            currentStage={0}
            title={<FormWizardTitle title={translate(Content.runsheet.export_form.title)} header={venueName} />}
            stages={[
                {
                    primaryButtonText: translate(Content.common.buttons.download),
                    primaryButtonCallback: () => onConfirm(daysToExport),
                    secondaryButtons: [
                        {
                            buttonText: translate(Content.common.buttons.cancel),
                            onButtonPressed: onClose,
                        },
                    ],
                    isValid: true,
                },
            ]}
        >
            <EnumToRadioButtons<DaysToExportType>
                radioButtons={[
                    {
                        name: translate(Content.runsheet.export_form.selected_day),
                        description: translate(Content.runsheet.export_form.selected_day_desc),
                        type: DaysToExportType.SELECTED_DAY,
                    },
                    {
                        name: translate(Content.runsheet.export_form.all_days),
                        description: translate(Content.runsheet.export_form.all_days_desc),
                        type: DaysToExportType.ALL_DAYS,
                    },
                ]}
                value={daysToExport}
                onChange={setDaysToExport}
            />
        </FormWizardTemplate>
    );
};
